import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import ReactGA from 'react-ga4';
import { HelmetProvider } from 'react-helmet-async';
import GAListener from "./shared/hooks/googleAnalytics/gaListener";
import App from "./App";
import './styles.css';

const root = ReactDOM.createRoot(document.getElementById("root"));

ReactGA.initialize(process.env.GOOGLE_ANALYTICS_ID);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <GAListener />
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
